// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from './application'

import ActionMenuController from './action_menu_controller'
application.register('action-menu', ActionMenuController)

import BundleEditorController from './bundle_editor_controller'
application.register('bundle-editor', BundleEditorController)

import BundleTreeController from './bundle_tree_controller'
application.register('bundle-tree', BundleTreeController)

import ClipboardController from './clipboard_controller'
application.register('clipboard', ClipboardController)

import ConditionsEditorController from './conditions_editor_controller'
application.register('conditions-editor', ConditionsEditorController)

import ConfirmController from './confirm_controller'
application.register('confirm', ConfirmController)

import DurationController from './duration_controller'
application.register('duration', DurationController)

import EditorModesController from './editor_modes_controller'
application.register('editor-modes', EditorModesController)

import EditorToolbarController from './editor_toolbar_controller'
application.register('editor-toolbar', EditorToolbarController)

import FileInputController from './file_input_controller'
application.register('file-input', FileInputController)

import FilterFormController from './filter_form_controller'
application.register('filter-form', FilterFormController)

import FilterMenuController from './filter_menu_controller'
application.register('filter-menu', FilterMenuController)

import FlashController from './flash_controller'
application.register('flash', FlashController)

import KeyValueRowsController from './key_value_rows_controller'
application.register('key-value-rows', KeyValueRowsController)

import LogViewerController from './log_viewer_controller'
application.register('log-viewer', LogViewerController)

import McpServerFormController from './mcp_server_form_controller'
application.register('mcp-server-form', McpServerFormController)

import McpSetupController from './mcp_setup_controller'
application.register('mcp-setup', McpSetupController)

import ModalController from './modal_controller'
application.register('modal', ModalController)

import ModalTriggerController from './modal_trigger_controller'
application.register('modal-trigger', ModalTriggerController)

import MonacoController from './monaco_controller'
application.register('monaco', MonacoController)

import MonacoDiffController from './monaco_diff_controller'
application.register('monaco-diff', MonacoDiffController)

import PanelResizeController from './panel_resize_controller'
application.register('panel-resize', PanelResizeController)

import RevisionDiffController from './revision_diff_controller'
application.register('revision-diff', RevisionDiffController)

import SearchSelectController from './search_select_controller'
application.register('search-select', SearchSelectController)

import SidebarController from './sidebar_controller'
application.register('sidebar', SidebarController)

import StreamRecoveryController from './stream_recovery_controller'
application.register('stream-recovery', StreamRecoveryController)

import ThemeController from './theme_controller'
application.register('theme', ThemeController)

import ToggleController from './toggle_controller'
application.register('toggle', ToggleController)

import WebhookConfigController from './webhook_config_controller'
application.register('webhook-config', WebhookConfigController)

import WebhookFormController from './webhook_form_controller'
application.register('webhook-form', WebhookFormController)

import WebhookSaveController from './webhook_save_controller'
application.register('webhook-save', WebhookSaveController)

import WorkflowCanvasController from './workflow_canvas_controller'
application.register('workflow-canvas', WorkflowCanvasController)

import WorkflowEditorController from './workflow_editor_controller'
application.register('workflow-editor', WorkflowEditorController)

import WorkflowJsonController from './workflow_json_controller'
application.register('workflow-json', WorkflowJsonController)

import WorkflowLaunchController from './workflow_launch_controller'
application.register('workflow-launch', WorkflowLaunchController)

import WorkflowSettingsController from './workflow_settings_controller'
application.register('workflow-settings', WorkflowSettingsController)

import WorkflowStepsController from './workflow_steps_controller'
application.register('workflow-steps', WorkflowStepsController)
